import { render } from "./pcIndex.vue?vue&type=template&id=474855f3"
import script from "./pcIndex.vue?vue&type=script&lang=js"
export * from "./pcIndex.vue?vue&type=script&lang=js"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__